import React from 'react';
import cx from 'classnames';

interface LabeledValueProps {
    label: string;
    value: string;
    maxWidth?: number;
    /**
     * A size used to scale the text and padding.
     * @defaultValue 'sm'
     */
    textSize?: 'xs' | 'sm';
}

/**
 * Renders a label / value pair with the label shown above the value.
 * @param props {@link LabeledValueProps}
 * @returns
 */
export const LabeledValue = ({
    label,
    value,
    textSize = 'sm',
    maxWidth,
}: LabeledValueProps): JSX.Element => {
    const textClasses = cx({
        'text-xs': textSize === 'xs',
        'text-sm': textSize === 'sm',
    });

    return (
        <div style={{ maxWidth }}>
            <div
                className={cx(textClasses, 'font-semibold', {
                    truncate: maxWidth !== undefined,
                })}
            >
                {label}
            </div>
            <div
                className={cx(textClasses, {
                    truncate: maxWidth !== undefined,
                })}
            >
                {value}
            </div>
        </div>
    );
};
